import request from '@/utils/request'
export function getList (params) {
  return request({
    url: '/hr/hrcase/page',
    method: 'GET',
	params
  })
}
export function getDetail (id) {
  return request({
    url: '/hr/hrcase/info/' + id,
    method: 'GET'
  })
}
export function getIndustry () {
  return request({
    url: '/sys/dict/type/all/case_industry',
    method: 'GET'
  })
}
export function getScene () {
  return request({
    url: '/sys/dict/type/all/case_scenario',
    method: 'GET'
  })
}